export default __webpack_public_path__ + "static/typson_lego-6056344fa23951facbfd26d5d3c7faef.png";